module.exports = __webpack_public_path__ + "static/media/gatefold_inner.91b23583.jpg";